import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Flex, Box } from 'reflexbox'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'
import { clientsQueries } from '../../graphql/queries'
import { termsQueries } from '../../graphql/queries'
import Modal from 'ui-components/lib/components/Modal'
import useModal from 'ui-components/lib/hooks/useModal'
import Alert from 'ui-components/lib/components/Alert'
import NaturalPersonAccountForm from './NaturalPerson'
import LegalPersonAccountForm from './LegalPerson'
import AccountUserModal from '../../components/Modal/AccountUserModal'
import { Loading } from '../../components'
import BreadCrumb from 'ui-components/lib/components/BreadCrumb'
import './styles.css'

const MyAccount = () => {
  const history = useHistory()
  const [openAccountUserModal, setOpenAccountUserModal] = useState(false)
  const [userType, setUserType] = useState('')

  const { isOpen: openClose, openModal: openCloseModal, closeModal: closeCloseAccount } = useModal()

  const { isOpen: openTerms, openModal: openTermsModal, closeModal: closeTerms } = useModal()
  const { isOpen: openPolicy, openModal: openPolicyModal, closeModal: closePolicy } = useModal()

  const breadcrumbLinks = [
    {
      label: 'Home',
      onClick: () => history.push('/dashboard')
    },
    {
      label: 'Minha conta'
    },
  ]

  const { data: privacyPolicyData, loading: privacyPolicyLoading } = useQuery(termsQueries.GET_PRIVACY_POLICY)

  const { data: termsOfUseData, loading: termsOfUseLoading } = useQuery(termsQueries.GET_TERMS_OF_USE)

  const { data: statusData } = useQuery(clientsQueries.GET_STATUS)
  const [fetchMyType, { data: dataMyType, loading: loadingMyType }] = useLazyQuery(clientsQueries.GET_TYPE)

  const myType = dataMyType?.me?.type

  const abrirCloseModal = () => {
    openCloseModal()
  }

  const handleOpenAddUserModal = (value) => {
    setOpenAccountUserModal(true)
    setUserType(value)
  }

  useEffect(() => {
    fetchMyType()
  }, [fetchMyType])

  useEffect(() => {
    if (statusData && statusData?.me?.status === 'incomplete') {
      history.push('/completar-cadastro')
    }
  }, [statusData]) // eslint-disable-line

  if (loadingMyType) return <Loading />

  return (
    <>
      <Flex width={1} justifyContent="center" flexDirection="column" className="service">
        <Flex width={1} mb={3} className="breadCrumb">
          <BreadCrumb ml={-3} navigationLinks={breadcrumbLinks} />
        </Flex>
      </Flex>
      <div className="my-account-container">
        <div className="my-account-content-wrapper">
          {/* Header Section */}
          <div className="my-account-header">
            <h1 className="my-account-title">Minha Conta</h1>
            <p className="my-account-subtitle">
              Gerencie suas informações pessoais, usuários e configurações da conta.
            </p>
          </div>

          <Flex width={1} flexDirection="column">
            <Box>
              <div className="my-account-alert-wrapper">
                <Alert
                  mb={0}
                  color="black"
                  message="Caso deseje alterar alguma informação abaixo, modifique o campo desejado e clique no botão salvar ao final do formulário."
                  noShadow
                  title="Seus dados pessoais"
                />
              </div>

            <div className="my-account-form-wrapper">
              {myType === 'natural' ? <NaturalPersonAccountForm /> : <LegalPersonAccountForm />}
            </div>

            <div className="my-account-actions-section">
              <button
                className="my-account-primary-button"
                onClick={() => handleOpenAddUserModal('Usuario')}
              >
                Adicionar usuário
              </button>

              <button
                className="my-account-link-button"
                onClick={() => openTermsModal()}
                disabled={!!termsOfUseLoading}
              >
                Termos de Serviço
              </button>

              <button
                className="my-account-link-button"
                onClick={() => openPolicyModal()}
                disabled={!!privacyPolicyLoading}
              >
                Política de Privacidade
              </button>

              <button
                className="my-account-link-button red"
                onClick={abrirCloseModal}
              >
                <strong>Encerrar conta</strong>
              </button>
            </div>
          </Box>
        </Flex>
      </div>

      <Modal
        id="closeModal"
        open={openClose}
        onClose={closeCloseAccount}
        header={<h4 style={{ padding: 0, margin: 10, color: 'var(--text-color)', transition: 'color 0.3s ease', fontFamily: 'Inter, sans-serif', fontSize: '20px', fontWeight: 600 }}>Instruções</h4>}
      >
        <p style={{ color: 'var(--text-color)', transition: 'color 0.3s ease', fontFamily: 'Inter, sans-serif', fontSize: '15px', lineHeight: '1.6' }}>
          Para solicitar o cancelamento, envie um e-mail para <a href="mailto:contato@bonuz.it" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--blue-bnz)', transition: 'color 0.3s ease', textDecoration: 'none', fontWeight: 500 }}>contato@bonuz.it</a> e entre em contato pelo WhatsApp <a href="https://api.whatsapp.com/send?phone=5511990213852&text=Ol%C3%A1,%20quero%20encerrar%20minha%20conta" target='_blank' rel="noopener noreferrer" style={{ color: 'var(--blue-bnz)', transition: 'color 0.3s ease', textDecoration: 'none', fontWeight: 500 }}>clique aqui</a>
        </p>
      </Modal>

      <Modal
        open={openTerms}
        onClose={closeTerms}
        boxProps={{ p: 28 }}
        contentModalProps={{ width: '80vw', maxWidth: '1200px' }}
        header={<h3 style={{ color: 'var(--text-color)', transition: 'color 0.3s ease', fontFamily: 'Inter, sans-serif', fontSize: '24px', fontWeight: 700 }}>Termos de Serviço</h3>}
        id="termsModal"
      >
        <Flex flexDirection="column">
          <Flex mt={3} flexDirection="column" style={{ color: 'var(--text-color)', transition: 'color 0.3s ease', fontFamily: 'Inter, sans-serif', fontSize: '15px', lineHeight: '1.8' }} dangerouslySetInnerHTML={{ __html: termsOfUseData?.termsOfUse?.content }} />
          <Flex justifyContent="flex-end" mt={4}>
            <button className="my-account-primary-button" onClick={() => closeTerms()} style={{ minWidth: '120px' }}>
              Fechar
            </button>
          </Flex>
        </Flex>
      </Modal>

      <Modal
        open={openPolicy}
        onClose={closePolicy}
        boxProps={{ p: 28 }}
        contentModalProps={{ width: '80vw', maxWidth: '1200px' }}
        header={<h3 style={{ color: 'var(--text-color)', transition: 'color 0.3s ease', fontFamily: 'Inter, sans-serif', fontSize: '24px', fontWeight: 700 }}>Política de Privacidade</h3>}
        id="policyModal"
      >
        <Flex flexDirection="column">
          <Flex mt={3} flexDirection="column" style={{ color: 'var(--text-color)', transition: 'color 0.3s ease', fontFamily: 'Inter, sans-serif', fontSize: '15px', lineHeight: '1.8' }} dangerouslySetInnerHTML={{ __html: privacyPolicyData?.privacyPolicy?.content }} />
          <Flex justifyContent="flex-end" mt={4}>
            <button className="my-account-primary-button" onClick={() => closePolicy()} style={{ minWidth: '120px' }}>
              Fechar
            </button>
          </Flex>
        </Flex>
      </Modal>

      <AccountUserModal
        openModal={openAccountUserModal}
        handleClose={() => setOpenAccountUserModal(false)}
        userType={userType}
      />
      </div>
    </>
  )
}

export default MyAccount
